import React from "react";
import styles from "../styles/SiteUpgrade.module.css";
import { GiUpgrade } from "react-icons/gi";


const SiteUpgrade = () => {
  return (
    <>
 


    <div className={styles.wrapper}>
  
      <div className={styles.card}>
        <GiUpgrade className={styles.spannerIcon}/>
    
        <h1 className={styles.title}>We&rsquo;re Updating Our Site</h1>

        <p className={styles.text}>
          Hodson Timber is currently undergoing an upgrade to improve your
          experience.
        </p>
        <p className={styles.text}>
          We&rsquo;ll be back shortly.
        </p>

      </div>
    </div>
        </>
  );
};

export default SiteUpgrade;